import { FadeIn, MaskedLine } from "@/components/Reveal";

export default function PageHeader({
    eyebrow,
    title,
    scriptWord,
    description,
    children,
}) {
    return (
        <section className="grain relative overflow-hidden pb-14 pt-36 sm:pb-20 sm:pt-44">
            <div
                className="absolute inset-0"
                style={{
                    background:
                        "radial-gradient(560px 340px at 12% 10%, rgba(255,0,127,0.1), transparent 60%), radial-gradient(640px 420px at 88% 60%, rgba(139,92,246,0.1), transparent 60%)",
                }}
            />
            <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
                <FadeIn>
                    <p className="eyebrow">{eyebrow}</p>
                </FadeIn>
                <h1 className="mt-5 font-display text-[8vw] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
                    <MaskedLine delay={0.1}>{title}</MaskedLine>
                    {scriptWord && (
                        <MaskedLine delay={0.24}>
                            <span className="animate-flicker font-script font-normal normal-case text-neon-pink neon-pink-text">
                                {scriptWord}
                            </span>
                        </MaskedLine>
                    )}
                </h1>
                {description && (
                    <FadeIn delay={0.4}>
                        <p className="mt-6 max-w-2xl text-base leading-relaxed text-fog sm:text-lg">
                            {description}
                        </p>
                    </FadeIn>
                )}
                {children}
            </div>
        </section>
    );
}
